var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.RESULTS.length ? 'ol-popup' : '',attrs:{"id":"popup"}},[_c('a',{attrs:{"href":"#","id":"popup-closer"}}),_c('div',{attrs:{"id":"popup-content"}},[(_vm.RESULTS.length)?_c('info-query',{on:{"close":function($event){return _vm.$emit('close')}}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }